import { apiPOST } from './api';

export const createCrudAction = ({ site_id: siteId, action_type: actionType }) => apiPOST(
  '/crud-actions',
  {
    site_id: siteId,
    action_type: actionType,
  }
);
